<template>
  <div :class="{ 'pt-16 lg:pt-0': !isAuthPage }">
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  name: 'App',

}
</script>

<style></style>
